import type { ComponentType } from 'react';
import { createContext } from 'react';

import type { AppConfigErrorScreen } from '../features/app-config/app-config-error-screen/app-config-error-screen';
import type { useLocations } from '../features/app-config/hooks/use-locations';
import type { useFeatureToggleConfig } from '../features/app-config/hooks/use-query/use-feature-toggle-config';
import type { useSelectedRootLocationConfiguration } from '../features/app-config/hooks/use-selected-root-location-configuration';
import type { useIsSchedulerEnabled } from '../features/checklist/checklist-scheduler/hooks/use-is-scheduler-enabled';
import type { useFeatureObservationsOnIdm } from '../hooks/feature-flags/use-feature-observations-on-idm';
import type { useIsDesktop } from '../hooks/useIsDesktop';
import type { useCurrentUserContext } from '../providers/current-user-provider/current-user-provider';
import type { useAppConfigContext } from '../providers/is-idm-provider/app-config-provider';

import type { MobileVersionPageType } from './page-layout';

export interface RoutesContextInterface {
  useAppConfigContext: typeof useAppConfigContext;
  useIsDesktop: typeof useIsDesktop;
  useFeatureObservationsOnIdm: typeof useFeatureObservationsOnIdm;
  useSelectedRootLocationConfiguration: typeof useSelectedRootLocationConfiguration;
  useCurrentUserContext: typeof useCurrentUserContext;
  useLocations: typeof useLocations;
  useFeatureToggleConfig: typeof useFeatureToggleConfig;
  useIsSchedulerEnabled: typeof useIsSchedulerEnabled;
  AppConfigErrorScreen: typeof AppConfigErrorScreen;
  PageLayout: ComponentType<{ page?: MobileVersionPageType }>;
  LandingPage: ComponentType;
  AppConfigView: ComponentType;
  UserProfilePage: ComponentType;
  ActivityDesktop: ComponentType;
  ActivityListView: ComponentType;
  ActivityPlanningView: ComponentType;
  ChecklistItemObservationListMobile: ComponentType;
  ActivityDetailsView: ComponentType;
  TemplatesMobile: ComponentType;
  TemplatesOverviewNew: ComponentType;
  TemplateCreatedConfirmationPage: ComponentType;
  SchedulesPage: ComponentType;
  ObservationsOverview: ComponentType;
  AssetDetails: ComponentType;
  Asset3d: ComponentType;
  AssetTrends: ComponentType;
  AssetProperties: ComponentType;
  AssetActivities: ComponentType;
  AssetNotifications: ComponentType;
  NotificationDetailsView: ComponentType;
  AssetDocuments: ComponentType;
  ActivityChecklistMobile: ComponentType;
  ObservationPageDesktop: ComponentType;
  ObservationDetailsMobile: ComponentType;
  IdmObservationsDesktopTablePage: ComponentType;
  IdmObservationsDesktopFormPage: ComponentType;
  IdmObservationsMobileListPage: ComponentType;
  IdmObservationMobileOverviewPage: ComponentType;
  PageNotFound: ComponentType;
  DataModelingOverridePage: ComponentType;
}

export const RoutesContext = createContext<RoutesContextInterface | null>(null);
